import React, { useState, useEffect } from "react";
import clsx from "clsx";
import PropTypes from 'prop-types';
import {
  Card,
  Typography,
  makeStyles,
  CardHeader,
  List,
  ListItem,
  ListItemText
} from '@material-ui/core';

import { SIREN_COLOR, SIREN_BOARD_ITEM_HEIGHT, SIREN_BOARD_TITLE_HEIGHT } from "config.js";
import firebase from '../../Firebase';
import 'firebase/database';
import {useSelector} from 'react-redux';
import { useIntl } from "react-intl";



const useStyles = makeStyles((theme) => ({

  root:{
  },
  title: {
    // color: theme.palette.secondary.contrastText,
    // color: "blue",
    // backgroundColor: theme.palette.secondary.main,
    color: theme.palette.primary.contrastText,
    // color: '#FFFFFF',
    // backgroundColor: theme.palette.primary.main,
    backgroundColor: SIREN_COLOR.ABSENCE_BG2_COLOR,
    height:SIREN_BOARD_TITLE_HEIGHT,
    padding: '8px 14px',
  },
  label: {
    marginLeft: theme.spacing(1),
  },
  labelbox: {
    margin: theme.spacing(2),
  },
  current: {
    marginTop: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
    // color: theme.palette.secondary.contrastText,
    // backgroundColor: theme.palette.secondary.main,
  },
  itemDivider: {
    height:SIREN_BOARD_ITEM_HEIGHT
  }
}));


function AbsenceBoard( {className, ...rest}) {

  const classes = useStyles();
  const {formatMessage} = useIntl();

  const [absenceTarget, setAbsenceTarget] = useState(0);
  const [presenceTarget, setPresenceTarget] = useState(0);

  const firebaseRootRef = useSelector((store) => store.envSettings.firebaseRootRef)


  useEffect(() => {

    if (firebaseRootRef == null || firebaseRootRef.length == 0) return;

    var dbRef = firebase.database().ref( '/dashboard/'+ firebaseRootRef ).child("dashboard").child("absence");

    dbRef.on('value', function(snapshot) {
      snapshot.forEach(function(childSnapshot){

        var childKey = childSnapshot.key;
        var childData = childSnapshot.val();

        if(childKey === "absence"){
          setAbsenceTarget(childData);
        }
        else if (childKey === "presence"){
          setPresenceTarget(childData);
        }

      });
    });

  }, []);


  const datas = [
    {
      label: formatMessage({id:'presence'}),
      value: presenceTarget,
    },
    {
      label: formatMessage({id:'absence'}),
      value: absenceTarget,
    }
  ];


  return (

    <Card
      className={clsx(classes.root, className)}
      {...rest}
      >

      <CardHeader
        className={classes.title}
        title={formatMessage({id:'absence_board_title'})}
        titleTypographyProps={{ color: 'inherit',  variant:'h6'}}
        subheader={formatMessage({id:'absence_board_subheader'})}
        subheaderTypographyProps={{ color: 'textSecondary', variant:'caption', align:'right'}}
      />


      <List>
        {datas.map((data) => (
          <ListItem classes={{ divider: classes.itemDivider}}
            divider
            key={data.label}>

            <ListItemText primary={data.label}
              primaryTypographyProps={{ color: 'textSecondary', variant: 'body1' }}/>
            <Typography color="inherit" variant="h5">{data.value}</Typography>
          </ListItem>
        ))}
      </List>


    </Card>
  );
}


AbsenceBoard.propTypes = {
  className: PropTypes.string
};

export default AbsenceBoard;

